import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withRouter } from "../Common/withRouter"
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import CommandPalette from "./CommandPalette"
import Rightbar from "../CommonForBoth/Rightbar"
import { ToastContainer } from "react-toastify"

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      searchOpen: false,
    }
    this.toggleMenuCallback = this.toggleMenuCallback.bind(this)
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this)
  }

  toggleRightSidebar() {
    this.props.toggleRightSidebar()
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  componentDidMount() {
    if (this.props.isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }

    // Scroll Top to 0
    window.scrollTo(0, 0)
    // let currentage = this.capitalizeFirstLetter(this.props.location.pathname)

    // document.title =
    //   currentage + " | Skote - Responsive Bootstrap 5 Admin Dashboard"
    if (this.props.leftSideBarTheme) {
      this.props.changeSidebarTheme(this.props.leftSideBarTheme)
    }

    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth)
    }

    if (this.props.leftSideBarType) {
      this.props.changeSidebarType(this.props.leftSideBarType)
    }
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme)
    }

    if (this.props.showRightSidebar) {
      this.toggleRightSidebar()
    }

    document.addEventListener("keydown", this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown)
  }

  handleKeyDown = event => {
    // Ctrl/⌘+K opens the quick page search from anywhere
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
      event.preventDefault()
      this.openSearch()
      return
    }
    if (event.key === "Escape" && !this.state.searchOpen && this.isMobileViewport() && this.isMobileSidebarOpen()) {
      this.toggleMenuCallback()
    }
  }

  openSearch = () => this.setState({ searchOpen: true })

  closeSearch = () => this.setState({ searchOpen: false })
  // Mobile/tablet layout per the `max-width: 992px` CSS breakpoint
  isMobileViewport = () => window.innerWidth <= 992

  isMobileSidebarOpen = () => document.body.classList.contains("sidebar-enable")

  componentDidUpdate(prevProps) {
    // Close the mobile drawer after navigating from it
    if (
      this.props.location?.pathname !== prevProps.location?.pathname &&
      this.isMobileViewport() &&
      this.isMobileSidebarOpen()
    ) {
      this.props.changeSidebarType("default", this.state.isMobile)
    }
  }

  // Decides from what is on screen (body classes), not Redux — the stored type
  // can be stale after the window is resized across the mobile breakpoint
  toggleMenuCallback = () => {
    if (this.isMobileViewport()) {
      const wasOpen = this.isMobileSidebarOpen()
      this.props.changeSidebarType(wasOpen ? "default" : "condensed", this.state.isMobile)
      // Move focus into the drawer when it opens, back to the hamburger when it closes
      const focusId = wasOpen ? "vertical-menu-btn" : "vp-sidebar-close"
      requestAnimationFrame(() => document.getElementById(focusId)?.focus())
      return
    }
    const isCollapsed = document.body.classList.contains("vertical-collpsed")
    this.props.changeSidebarType(isCollapsed ? "default" : "condensed", this.state.isMobile)
  }

  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner-chase">
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
              <div className="chase-dot"></div>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header
            toggleMenuCallback={this.toggleMenuCallback}
            onOpenSearch={this.openSearch}
          />
          <Sidebar onToggle={this.toggleMenuCallback} />
          {/* Overlay — closes sidebar when tapped on mobile */}
          <div
            className="sidebar-overlay"
            onClick={this.toggleMenuCallback}
            aria-hidden="true"
          />
          <div className="main-content">{this.props.children}</div>
          <Footer />
        </div>
        <CommandPalette isOpen={this.state.searchOpen} onClose={this.closeSearch} />
        <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} closeOnClick pauseOnHover />
        <Rightbar />
      </React.Fragment>
    )
  }
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.bool,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  toggleRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any
}

const mapStateToProps = state => {
  return {
    ...state.Layout,
  }
}
export default connect(mapStateToProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  toggleRightSidebar,
  changeTopbarTheme,
  changeLayoutWidth,
})(withRouter(Layout))
